function readText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function normalizeTrackingValue(value, fallback) {
  const text = readText(value)
    .replace(/<[^>]*>/g, ' ')
    .toLowerCase();

  const normalized = text
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  return normalized || fallback;
}

function getCurrentRoute(routeOverride) {
  return routeOverride || document.body.getAttribute('data-app-route') || '';
}

function getActiveSlideTitle(appRoot) {
  const activeDot = appRoot.querySelector('[data-route-view="slides"] .dot.active');
  const activeIndex = activeDot ? parseInt(activeDot.getAttribute('data-dot-index'), 10) : 0;
  const activeSlide = appRoot.querySelector(
    '[data-route-view="slides"] .slides-data__item[data-slide-index="' + activeIndex + '"]'
  );
  const activeTitle = activeSlide ? activeSlide.getAttribute('data-title') : '';
  const introTitle = appRoot.querySelector('[data-route-view="slides"] .slides-intro .text-card__title');

  return activeTitle || (introTitle ? introTitle.textContent : '') || 'slides';
}

function getActiveSummaryTitle(appRoot) {
  const activeScreen = appRoot.querySelector('[data-route-view="summary"] .summary-page__screen--active');
  if (!activeScreen) {
    return 'summary';
  }

  const title = readText(activeScreen.textContent);
  return title || 'summary';
}

function resolveControlName(control) {
  if (!control || control.hidden || control.disabled) {
    return '';
  }

  if (control.getAttribute('aria-disabled') === 'true' || control.classList.contains('disabled')) {
    return '';
  }

  if (control.classList.contains('grade-item')) {
    return normalizeTrackingValue('hearing_' + (control.dataset.grade || 'normal'), 'hearing_change');
  }

  if (control.id === 'replayBtn') {
    return 'replay';
  }

  if (control.id === 'forwardBtn') {
    return 'next_slide';
  }

  if (control.classList.contains('slides-ref-modal__close')) {
    return 'close_references';
  }

  const dataName = control.getAttribute('data-gtm-event');
  if (dataName) {
    return normalizeTrackingValue(dataName, 'interaction');
  }

  const ariaLabel = control.getAttribute('aria-label');
  if (ariaLabel) {
    return normalizeTrackingValue(ariaLabel, 'interaction');
  }

  const text = readText(control.textContent);
  if (text) {
    return normalizeTrackingValue(text, 'interaction');
  }

  return normalizeTrackingValue(control.id || control.className || '', 'interaction');
}

export function resolveTrackedSlideName(appRoot, routeOverride) {
  const route = getCurrentRoute(routeOverride);

  if (!appRoot) {
    return normalizeTrackingValue(route, 'unknown');
  }

  if (route === 'slides') {
    return normalizeTrackingValue(getActiveSlideTitle(appRoot), 'slides');
  }

  if (route === 'summary') {
    return normalizeTrackingValue(getActiveSummaryTitle(appRoot), 'summary');
  }

  return normalizeTrackingValue(route, 'unknown');
}

export function pushGtmEvent(buttonName, slideName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'button_click',
    buttonName: normalizeTrackingValue(buttonName, 'interaction'),
    slideName: normalizeTrackingValue(slideName, 'unknown')
  });
}

export function trackPageView(appRoot, routeOverride) {
  pushGtmEvent('page_view', resolveTrackedSlideName(appRoot, routeOverride));
}

export function trackNamedEvent(scope, eventName, routeOverride) {
  const appRoot = scope ? scope.closest('[data-app-root]') : null;
  pushGtmEvent(eventName, resolveTrackedSlideName(appRoot, routeOverride));
}

export function bindButtonTracking(appRoot) {
  if (!appRoot || appRoot.__gtmTrackingBound) {
    return;
  }

  appRoot.__gtmTrackingBound = true;
  appRoot.addEventListener('click', function (event) {
    const control = event.target.closest('button, a');
    if (!control || !appRoot.contains(control)) {
      return;
    }

    if (control.id === 'replayBtn' || control.id === 'forwardBtn') {
      return;
    }

    const controlName = resolveControlName(control);
    if (!controlName) {
      return;
    }

    pushGtmEvent(controlName, resolveTrackedSlideName(appRoot));
  });
}